import SearchInput from "@/app/components/SearchInput";
import { statusLabel } from "../enquiry";

type Status = "all" | "new" | "qualified" | "converted" | "rejected";

interface EnquiryFiltersProps {
  statuses: readonly Status[];
  activeFilter: Status;
  onFilterChange: (status: Status) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusCounts: Record<Status, number>;
}

export default function EnquiryFilters({
  statuses,
  activeFilter,
  onFilterChange,
  searchQuery,
  onSearchChange,
  statusCounts,
}: EnquiryFiltersProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 mb-4 bg-white rounded-xl p-3 sm:p-4 border border-stone-200">
      <div className="flex gap-2 overflow-x-auto -mx-1 px-1 pb-1 lg:pb-0" role="group" aria-label="Status">
        {statuses.map(s => (
          <button
            key={s}
            type="button"
            onClick={() => onFilterChange(s)}
            aria-pressed={activeFilter === s}
            className={`shrink-0 min-h-10 md:min-h-9 px-3.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors ${
              activeFilter === s
                ? "text-white bg-amber-500 shadow-sm"
                : "bg-stone-50 text-stone-600 border border-stone-200 hover:bg-stone-100"
            }`}
          >
            {s === "all" ? "All" : statusLabel(s)} <span className="opacity-60">({statusCounts[s]})</span>
          </button>
        ))}
      </div>
      <SearchInput
        value={searchQuery}
        onChange={onSearchChange}
        placeholder="Search name, phone, email, type…"
        className="w-full lg:w-72 min-h-10"
      />
    </div>
  );
}
